module.exports = __webpack_public_path__ + "static/Simtrim-Basic-Installation-Instructions-5a21530eb467ef6d8dec741121acdcd0.pdf";